import {Box, Button, Drawer, Stack, Typography} from '@mui/material'
import React from 'react'

type EditSheetProps = {
  open: boolean,
  title: string,
  onClose: () => void,
  onValidate: () => void,
  onDelete?: () => void,
  children: React.ReactNode,
}

export const EditSheet: React.FC<EditSheetProps> = ({open, title, onClose, onValidate, onDelete, children}) => {
  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
          width: '100vw',
          maxWidth: '100vw',
          boxSizing: 'border-box',
          overflow: 'hidden',
        },
      }}
    >
      <Box
        sx={{
          p: 2,
          pb: 'calc(16px + env(safe-area-inset-bottom))',
          width: '100%',
          maxHeight: '85dvh',
          boxSizing: 'border-box',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        <Typography variant="h6" sx={{mb: 2}}>{title}</Typography>
        <Stack spacing={2}>{children}</Stack>

        <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'space-between', alignItems: 'center', mt: 3}}>
          <Box>
            {onDelete && (
              <Button color="error" onClick={onDelete}>Supprimer</Button>
            )}
          </Box>
          <Box sx={{display: 'flex', gap: 1}}>
            <Button onClick={onClose}>Annuler</Button>
            <Button variant="contained" onClick={onValidate}>Valider</Button>
          </Box>
        </Box>
      </Box>
    </Drawer>
  )
}
